import {GlobalRoutePath} from "@router/constants";

export const fullPath = path => `${GlobalRoutePath.SETTINGS.path}/${path}`;
const SettingsPath = {
    DEFAULT: {
      path: "/",
      privilege:"SERVICE SUBSCRIPTION",
      index:0
    },
    SERVICE_SUBSCRIPTION: {
      path: "servicesubscription",
      privilege:"SERVICE SUBSCRIPTION",
      index:1
    },
    PAYERS_MEASURES: {
      path: "payersandmeasures",
      privilege:"PAYER MEASURE",
      index:2
    },
  
    CLINIC_MANAGEMENT: {
      path: "clinicmanagement",
      privilege:"CLINIC MANAGEMENT",
      index:3
    },
    USER_MANAGEMENT: {
      path: "usermanagement",
      privilege:"USER MANAGEMENT", 
      index:5
    },
    CUSTOMIZE_APP: {
      path: "customizeapp",
      privilege:"APP CUSTOMIZATION",
      index:6
    },
    USER_ROLE_MANAGEMENT: {
      path: "userrolemanagement",
      privilege: "ROLE MANAGEMENT",
      index:7
    },
    DATA_IMPORT: {
      path: "dataimport",
      privilege:"DATA",
      index:8
    },
    SMART_SCHEDULER: {
      path: "smartscheduler",
      privilege:"SMART_SCHEDULER_ADMIN",
      index:9
    },
    LR_INTEGRATION: {
      path: "lr-integration",
      privilege:"LR_INTEGRATION_ADMIN",
      productKey:"lr_bundle",
      index:10
    },
    HELP: {
      path: "helpcenter",
      index:11
    }
  };
export const SettingsRoutePath = {};  
Object.keys(SettingsPath).forEach(rkey=>{
  SettingsRoutePath[rkey] = {...SettingsPath[rkey],fullPath:fullPath(SettingsPath[rkey].path)};
})
export const activeSettingsPath = (privileges)=>{
    const paths = Object.values(SettingsRoutePath).filter(p=>p.index>0 && (!p.privilege || privileges.includes(p.privilege))).sort((a,b)=>a.index-b.index);
    return paths;
}


export const settingsNavItems = [
  {
    headerTitle: "Settings",
    subHeader: [
      {
        label: "Service Subscription",
        privilege:SettingsRoutePath.SERVICE_SUBSCRIPTION.privilege,
        to: SettingsRoutePath.SERVICE_SUBSCRIPTION.fullPath,
        icon:"/static/images/subscription.svg",
        default: true
      },
      {
        label: "Payers and Measures",
        privilege:SettingsRoutePath.PAYERS_MEASURES.privilege,
        to: SettingsRoutePath.PAYERS_MEASURES.fullPath,
        icon:"/static/images/clinic.svg",
        default: false
      },
      {
        label: "Clinic Locations",
        privilege:SettingsRoutePath.CLINIC_MANAGEMENT.privilege,
        to: SettingsRoutePath.CLINIC_MANAGEMENT.fullPath,
        icon:"/static/images/clinic.svg",
        default: false
      },
      {
        label: "Logo Setup",
        privilege:SettingsRoutePath.CUSTOMIZE_APP.privilege,
        to: SettingsRoutePath.CUSTOMIZE_APP.fullPath,
        icon:"/static/images/customize.svg",
        default: false
      },
      {
        label: "Users",
        id: "user-management",
        to: SettingsRoutePath.USER_MANAGEMENT.fullPath,
        icon:"/static/images/users.svg",
        privilege:SettingsRoutePath.USER_MANAGEMENT.privilege, 
        default: false
      },	

      {
        label: "User Roles",
        id: "role-management",
        privilege: SettingsRoutePath.USER_ROLE_MANAGEMENT.privilege,
        icon:"/static/images/user-roles.svg",
        to: SettingsRoutePath.USER_ROLE_MANAGEMENT.fullPath,
        },
      {
        label: "Data Import",
        to: SettingsRoutePath.DATA_IMPORT.fullPath,
        icon:"/static/images/data-import.svg",
        privilege:SettingsRoutePath.DATA_IMPORT.privilege,
        default: false
      },	
      {
        label: "Smart Scheduler Settings",
        to: SettingsRoutePath.SMART_SCHEDULER.fullPath,
        icon:"/static/images/smart-scheduler.svg",
        privilege:SettingsRoutePath.SMART_SCHEDULER.privilege,
        default: false
      },	
      {
        label: "LR Interoperability",
        to: SettingsRoutePath.LR_INTEGRATION.fullPath,
        icon:"/static/images/integration.png",
        productKey:SettingsRoutePath.LR_INTEGRATION.productKey,
        privilege:SettingsRoutePath.LR_INTEGRATION.privilege,
        default: false
      },				
      {
        label: "Help Center",
        icon:"/static/images/help.svg",
        to: SettingsRoutePath.HELP.fullPath,
        default: false
      }	
    ]
  },
];
export const settingsNavLinks = (privileges,products)=>settingsNavItems.map(s=>({...s,subHeader:activeSettingsNavLinks({privileges,products,navLinks:s.subHeader})}))
export const activeSettingsNavLinks = ({privileges,products,activeLinks,excludes=[SettingsRoutePath.HELP.fullPath],navLinks})=>{
  const links = (navLinks || settingsNavItems[0].subHeader).filter(p=>!excludes.includes(p.to) && (!p.privilege || privileges.includes(p.privilege)) && (!p.productKey || (products||[]).includes(p.productKey)) && (!activeLinks || activeLinks.includes(p.id)));
  return links.sort((a,b)=>a.label.localeCompare(b.label));
}